export default {
    init() {
        $(window).ready(function () {
            $.ajax({
                url: '/get-related-video',
                type: 'GET',
                data: {
                    url: window.location.pathname
                },
                success: function (response) {
                    let relatedVideo = response.related_video
                    if (relatedVideo && relatedVideo.length > 0) {
                        const target = window.location.pathname.replaceAll('/', '_');
                        let videoModalButton = $(
                            '<button type="button" data-target="' + target + '" class="video_guides__input-label d-none d-md-flex">' +
                            '<img class="open-modal" src="/images/video-button.png"/>' +
                            '</button>');
                        let videosHtml = '<div id="video-modal_' + target + '" class="video_guides__modal-video">' +
                                '<div class="video_guides__modal-video-content">';
                        let videoModal ='';
                        relatedVideo.forEach(element => {
                            videoModal +=
                                        `<div class="video_guides__modal-video-wrapper">`+
                                            `<div class="video_guides__modal-video-name">Video: ${element.title}`+
                                            `</div>`+
                                            `<div class="video_guides__modal-video-description mb-1">${element.description}`+
                                            `</div>`+
                                            '<video class="video_guides__video" id="video-guide_' + element.id + '" muted preload="metadata" controls>' +
                                                '<source src="' + element.local_path + '" type="video/mp4">' +
                                            '</video>' +
                                        '</div>';
                        });
                        videosHtml += videoModal;
                        videosHtml += '</div></div>';

                        $('body').append(videosHtml, videoModalButton);

                        $(".video_guides__input-label").click(function(event) {
                            event.preventDefault()
                            let target = $(this).data("target")
                            $("#video-modal_" + target).show();
                            //$("#video-guide_" + target)[0].play();
                        })

                        $(".video_guides__close").click(function() {
                            let target =  $(this).data("target")
                            $("#video-modal_" + target).hide();
                            stopVideos()
                        });

                        $(window).click(function(event) {
                            if ($(event.target).hasClass('video_guides__modal-video')) {
                                $("#" + event.target.id).hide();
                                stopVideos();
                            }
                        });
                    }
                },
                error: (response) =>{

                },
            })
        })

        $(".open-modal").click(function(event) {
            event.preventDefault()
            let target = $(this).data("target")
            $("#video-modal_" + target).show();
            $("#video-guide_" + target)[0].play();
        });

        $('#video_file').on('input', function (event) {
            let file =  event.target.files[0];

            let videoPreview = $('#video_preview')
            videoPreview.attr('src', URL.createObjectURL(file))
            videoPreview.show();
        })

        $(window).click(function(event) {
            if ($(event.target).hasClass('video_guides__modal-video')) {
                $("#" + event.target.id).hide();
                stopVideos();
            }
        });

        $(".delete-video").click(function(event) {
            event.preventDefault()
            $.ajax({
                url: event.target.href,
                method: 'delete',
                success: () => {
                    window.location.reload()
                }
            })
        })

        $("#add_url_line").click(function() {
            $(this).before(
                '<input name="urls[]" type="text" class="modal-video-guides__body-wrapper-url" placeholder="URL for presenting the video">'
            )
        })

        $(".modal-video-guides__body-wrapper-url-edit-close").click(function () {
            $('#' + $(this).data('index')).remove()
            $(this).remove()
        })

        $("#save-video-guide-form").submit(function(e){
            e.preventDefault();
            let button = $('#video-guide__submit_button')
            let spinner = $('#spinner')

            button.hide()
            spinner.show()

            let form = $(this)
            let fd = makeFormData(form)

            $.ajax({
                url: form.attr('action'),
                method: form.attr('method'),
                data: fd,
                contentType: false,
                processData: false,
                success: function (response) {
                    window.location.href = response.href;
                },
                error: function (response) {
                    spinner.hide()
                    button.show()
                    if (response.status == '422') {
                        let errorWrapper = $('.modal-video-guides__body-wrapper-errors')

                        errorWrapper.html('');
                        for (let errorKey in response.responseJSON.errors) {
                            errorWrapper.append('<div style="margin-bottom: 5px;">' + response.responseJSON.errors[errorKey] + '</div>');
                        }
                        errorWrapper.removeClass('d-none');
                    }

                }
            })
        });

        function makeFormData(form) {
            let fileInput = $('.video_guides__file-input-label').find('#video_file')
            let fd = new FormData();

            form.serializeArray().map(field => {
                fd.append(field.name, field.value)
            })

            fd.append('video', fileInput[0].files[0])

            return fd
        }

        function stopVideos() {
            $(".video_guides__modal-video-content video").each(function() {
                if (this.paused === false) {
                    this.pause();
                    this.currentTime = 0;
                }
            });
        }

        $('.video_guides__file-input-label input[type=file]').on('change', function(){
            let file = this.files[0];

            $(this).closest('.video_guides__file-input-label').find('.video_guides__file-input-text').html(file.name);
        });
    },
}
